








































import Vue, { PropType } from 'vue';
// import { Item } from '@/modules/exhibitor/item';
import { Item } from 'mostra';

interface CategoryOption {
  value: number;
  text: string;
}

export default Vue.extend({
  name: 'GSelectItemlist',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    title: {
      type: String as PropType<string>,
      default: '商品を選択',
    },
    categoryOptions: {
      type: Array as PropType<CategoryOption[]>,
      default: () => [],
    },
    onClick: {
      type: Function as PropType<() => void>,
    },
    listItems: {
      type: Array as PropType<Item[]>,
      default: () => [],
    },
    headerWithCheckBox: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    value: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    buttonDisabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    selectDisabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get(): string[] {
        return this.value;
      },
      set(val: string[]): void {
        this.$emit('input', val);
      },
    },
  },
});
